import type { MetadataProviderFragment } from '~~/lib/ContentfulGraphqlService';

export function isMetaDataProviderFragment(
  input: unknown
): input is MetadataProviderFragment & { slug?: string } {
  return typeof input === 'object' && input != null && 'slug' in input;
}
